<template>
  <div style="width: 100%;height: 100%">
      <div style="height: 90px">
        <case-search @search="search"></case-search>
      </div>
      <Row :gutter="16">
        <Col span="20">
          <case-table :searchMap="searchMap"></case-table>
        </Col>
        <Col span="4">
          <scan-number></scan-number>
        </Col>
      </Row>
  </div>
</template>

<script>
import CaseSearch from '../../base/search/CaseSearch'
import CaseTable from '../../base/table/CaseTable'
import ScanNumber from '../../base/scan/ScanNumber'
export default {
  name: 'caseManager',
  components: {CaseSearch, CaseTable, ScanNumber},
  data () {
    return {
      searchMap: new Map(),
      isFixedScan: false
    }
  },
  mounted () {
    // 绑定监听滚动条事件，及处理方法
    window.addEventListener('scroll', this.handlerScroll)
  },
  methods: {
    // 传递查询参数
    search (map) {
      this.searchMap = map
    },
    handlerScroll () {
      // 当前滚动条距顶部的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // 目标div距顶部的距离，此处会随着滚动后使用的不同样式发生变化
      let offsetTop = document.querySelector('.scan-number').offsetTop
      // 根据需要调整，如果滚动到了距顶部小于80时，替换掉原本的position
      if (offsetTop - scrollTop < 80) {
        this.isFixedScan = true
      }
      // 如果两者和小于177时，替换为原本的position
      if (offsetTop + scrollTop < 175) {
        this.isFixedScan = false
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  .layout-logo{
    margin-top: -10px;
    width: 100px;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    float: left;
    position: relative;
    top: 15px;
    left: 20px;
  }
  .layout-nav{
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
  }
  .scan-number
    width 15%
    height 65%
    position absolute
    top 182px
    right 3%
  .scan-fixed
    position fixed
    top 80px
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/CaseManager.vue